// src/Pages/ArticlePage.js
import React from "react";
import ReactMarkdown from "react-markdown";
import { Github } from "lucide-react";
import article from "../articles/automating-elevated-tasks";

export default function ArticlePage() {
    const published = article.published || article.date;

    return (
        <div className="max-w-3xl mx-auto bg-slate-900 text-white p-6">
            {/* Title + GitHub button */}
            <div className="flex items-start justify-between gap-4">
                <h1 className="text-4xl font-bold">{article.title}</h1>

                {article.repoUrl && (
                    <a
                        href={article.repoUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 rounded-lg border border-slate-700 px-3 py-2 text-slate-200 hover:bg-slate-800"
                        aria-label="View repository on GitHub"
                        title="View on GitHub"
                    >
                        <Github className="w-4 h-4" />
                        <span className="hidden sm:inline">GitHub</span>
                    </a>
                )}
            </div>

            {/* Meta */}
            <div className="mt-2 mb-6 text-slate-400">
                {published && <span>{published}</span>}
                {article.readingTime && (
                    <>
                        {" "}
                        · <span>{article.readingTime}</span>
                    </>
                )}
                {article.tags?.length ? (
                    <div className="mt-2 flex flex-wrap gap-2">
                        {article.tags.map((tag) => (
                            <span
                                key={tag}
                                className="bg-cyan-700 rounded-full px-3 py-1 text-xs font-semibold"
                            >
                                {tag}
                            </span>
                        ))}
                    </div>
                ) : null}
            </div>

            {/* Hero image */}
            {article.image && (
                <img
                    src={article.image}
                    alt={article.title}
                    className="rounded-lg mb-6 w-full max-h-96 object-cover border border-slate-800"
                />
            )}

            {/* Optional summary */}
            {article.summary && (
                <p className="text-slate-200 mb-6">{article.summary}</p>
            )}

            {/* Markdown */}
            <article className="prose prose-invert prose-lg max-w-none">
                <ReactMarkdown>{article.content}</ReactMarkdown>
            </article>
        </div>
    );
}
